import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './RichTextEditor.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  minHeight?: string;
}

/**
 * Uncontrolled rich text editor.
 * Uses `defaultValue` so Quill manages its own state internally.
 * Parent must change the `key` prop to reset/remount with new content.
 */
const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter description...',
  className = '',
  minHeight = '200px',
}) => {
  // Toolbar configuration
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['blockquote', 'code-block'],
        ['link'],
        ['clean'],
      ],
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'align',
    'list',
    'indent',
    'blockquote',
    'code-block',
    'link',
  ];

  return (
    <div className={`rich-text-editor-wrapper ${className}`} style={{ minHeight }}>
      <ReactQuill
        theme="snow"
        defaultValue={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ height: '100%' }}
      />
    </div>
  );
};

export default RichTextEditor;
